import { tns } from 'tiny-slider';

(function (Drupal, once) {

  Drupal.behaviors.paragraphTicker = {
    attach: function (context, settings) {
      const tickers = once('paragraph-tickers', '.paragraph--type--ticker', context);

      tickers.forEach((tickerWrapper) => {
        const containerEl = tickerWrapper.querySelector('.ticker-items > .field__items');

        let tickerMaxCount = 1;
        let tickerAutoplay = false;
        let tickerNav = false;

        if (tickerWrapper.classList.contains('ticker-autoplay')) {
          tickerAutoplay = true;
        }

        if (tickerWrapper.classList.contains('ticker-nav')) {
          tickerNav = true;
        }

        if (tickerWrapper.classList.contains('ticker-count-1')) {
          tickerMaxCount = 1;
        }

        if (tickerWrapper.classList.contains('ticker-count-2')) {
          tickerMaxCount = 2;
        }

        if (tickerWrapper.classList.contains('ticker-count-3')) {
          tickerMaxCount = 3;
        }

        if (tickerWrapper.classList.contains('ticker-count-4')) {
          tickerMaxCount = 4;
        }

        if (tickerWrapper.classList.contains('ticker-count-6')) {
          tickerMaxCount = 6;
        }

        const ticker = new tns({
          container: containerEl,
          slideBy: "page",
          items: 1,
          autoplay: tickerAutoplay,
          gutter: 10,
          //autoHeight: true,
          autoplayButtonOutput: false,
          nav: tickerNav,
          navPosition: 'bottom',
          controlsText: ['', ''],
          controlsPosition: 'bottom',
          preventScrollOnTouch: 'auto',
          responsive: {
            1500: {
              items: tickerMaxCount
            },
            1000: {
              items: 2
            },
          }
        });

      });
    }
  }

}(Drupal, once));
